import React from "react";

import "./StartNow.scss";

import {
  IconAddUser,
  IconSolution,
  IconFinance,
} from "../../../../assets/index";

const menu = [
  {
    id: 0,
    icon: <IconAddUser />,
    title: "Đăng ký Mytour Affiliate",
    desc: "Chỉ mất vài phút",
    step: 1,
  },
  {
    id: 1,
    icon: <IconSolution />,
    title: "Cài đặt Affiliate",
    desc: "Chọn một loạt các giải pháp để thúc đẩy chuyển đổi từ trang web của bạn.",
    step: 2,
  },
  {
    id: 2,
    icon: <IconFinance />,
    title: "Bắt đầu kiếm thêm thu nhập!",
    desc: "Nhận một phần doanh thu khi người đọc của bạn đặt dịch vụ qua link Mytour Affiliate",
    step: 3,
  },
];
const StartNow = () => {
  return (
    <div className="StartNow">
      <div className="title">
        Bắt đầu ngay hôm nay
        <span className="desc">Chỉ với 3 bước đơn giản</span>
        <div className="line" />
      </div>

      <div className="wrapListItem">
        {menu.map((el, index) => (
          <div className="box" style={{ padding: index === 1 ? "0 100px" : 0 }}>
            <div className="item" key={index}>
              <div className="icon">{el.icon}</div>
              <div className="wrap_step">
                <div className="wrap_desc">
                  <span className="box_desc">
                    <span className="title">{el.title}</span>
                    <span className="desc">{el.desc}</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="step">{el.step}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StartNow;
